export const GET_PS_USER_ROLE = 'pstrans/pstable/GET_PS_USER_ROLE';
export const SET_PS_USER_ROLE = 'pstrans/pstable/SET_PS_USER_ROLE';
export const SET_SEL_PS = 'pstrans/pstable/SET_SEL_PS';
